import React, { useState } from "react";
import {
  Modal,
  Box,
  SpaceBetween,
  Button,
  Icon,
  Alert
} from "@cloudscape-design/components";
import { ActionConfirmationModalProps } from "types/extensionTypes";









const ActionConfirmationModal: React.FC<ActionConfirmationModalProps> = ({
  isVisible,
  isLoading,

  onDismiss,
  onConfirm,

  headerText = "Confirmation",
  headerIconName = "check",

  mainButtonText = "Confirm",
  mainButtonLoadingText = "Processing...",

  children,
}) => {

  const [error, setError] = useState<string |null>(null);


  const handleDismiss = () => {
    if (isLoading) return;

    setError(null);
    onDismiss();
  };


  const handleConfirm = async () => {
    try {
      setError(null);
      
      await onConfirm();

      handleDismiss();
      
    } catch (error) {

      if((error as any)?.response?.data?.code == "EXTENSION_VERSION_INCOMPATIBLE"){
        setError((error as any)?.response?.data?.message);

      }else{
        setError("Failed to install extension. Please try again.");
      }
    }
  };



  return (
    <Modal
      onDismiss={() => {
        handleDismiss();
      }}
      visible={isVisible}
      closeAriaLabel="Close modal"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button
              variant={"primary"}
              onClick={handleConfirm}
              loading={isLoading}
            >
              {isLoading ? mainButtonLoadingText : mainButtonText}
            </Button>
            <Button
              variant="link"
              onClick={handleDismiss}
              disabled={isLoading}
            >
              Cancel
            </Button>
          </SpaceBetween>
        </Box>
      }
      header={
        <SpaceBetween direction="horizontal" alignItems="center" size="xs">
          <Icon name={headerIconName} />
          <Box variant="h3">{headerText}</Box>
        </SpaceBetween>
      }
    >
      <SpaceBetween size="l">
        <div>{children}</div>

        {error && <Alert type="error">
          {error}
        </Alert>}
      </SpaceBetween>
    </Modal>
  );
};

export default ActionConfirmationModal;